import { render, staticRenderFns } from "./Otp1.vue?vue&type=template&id=3cec5a9e&"
import script from "./Otp1.vue?vue&type=script&lang=js&"
export * from "./Otp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports